import React, { createElement } from 'react';
import { Helmet } from 'react-helmet';
import Header from './components/Header';
import ArticleContent from './components/ArticleContent';
import Sidebar from './components/Sidebar';
import Footer from './components/Footer';
import MetaPixel from './components/MetaPixel';
export function App() {
  return <>
      <MetaPixel data-id="element-0" />
      <div className="flex flex-col min-h-screen bg-gray-100" data-id="element-1">
        <Header data-id="element-2" />
        <div className="flex flex-col md:flex-row max-w-6xl mx-auto w-full px-4 py-6 bg-white" data-id="element-3">
          <main className="w-full md:w-2/3 pr-0 md:pr-8" data-id="element-4">
            <ArticleContent data-id="element-5" />
          </main>
          <aside className="w-full md:w-1/3 mt-8 md:mt-0" data-id="element-6">
            <Sidebar data-id="element-7" />
          </aside>
        </div>
        <Footer data-id="element-8" />
      </div>
    </>;
}